import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToasterComponent } from './shared/toaster/toaster.component';
import { HttpClientModule } from '@angular/common/http';
import { ToasterService } from './shared/toaster/toaster.service';
import { CallService } from './services/features/call.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, ToasterComponent, HttpClientModule],  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(){

  }
}